const EducationDetails = () => {
  return <div>test</div>;
};

export default EducationDetails;
